// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"e306ae44","236":"2d127c7f","513":"80b3c9e4","658":"0c15a7d7","703":"a51f0d9e","787":"84dcd68a","837":"675ebd71"}[chunkId] + ".chunk.js";
};